import React from "react";
import Header from "./components/Header";
import Details from "./components/Details";
import { useEditViewController } from "./hooks"

const EditView: React.FC = () => {
  const controller = useEditViewController({});

  return (
    <>
      <Header id={controller.id} view={controller.view} loading={controller.getContentLoading} transactionStatus={controller.formData.status} />

      <Details loading={controller.getContentLoading} formData={controller.formData} />

      {controller.content}
    </>
  );
};

export default EditView;
